import { Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';
import { AppComponentBase } from '@shared/app-component-base';
import { ToRequestCityDto, UserPermissionAddressDto, UserPermissionServiceProxy } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { TestService } from 'test/service/test.service';

@Component({
  selector: 'kt-to-request-transfer',
  templateUrl: './to-request-transfer.component.html',
  styleUrls: ['./to-request-transfer.component.scss']
})
export class ToRequestTransferComponent extends AppComponentBase implements OnInit, OnDestroy {

    //Dynamic olarak oluşturulan component içerisinde ki datayı 
  //parent component içerisinde yakalamamızı sağlar.
  //Yayınlancak dynamic component dataları demektir.
  dynamicComponentObject = new Subject();

  /** control for the MatSelect filter keyword */
	public addressSearchFilter: FormControl = new FormControl();

	/** list of banks filtered by search keyword */
	//public AddressList: ReplaySubject<StaticSalesmanAddressPto[]> = new ReplaySubject<StaticSalesmanAddressPto[]>(1);

	/** Subject that emits when the component has been destroyed. */
	protected _onDestroy = new Subject<void>();
	
	cities= new Subject<ToRequestCityDto[]>();

   //Anlık olarak ngModel ile tutulan şehirleri combobox datasını yakalar
	selectedCity = new ToRequestCityDto();

	//Anlık olarak ngModel ile tutulan lokasyonları datasını yakalar
	selectedAddressObj = new UserPermissionAddressDto();

  locationObjListByCity = new BehaviorSubject<UserPermissionAddressDto[]>([]);
	locationByCity: UserPermissionAddressDto[] = [];
	initialLocationByCity: UserPermissionAddressDto[] = [];

  

	selectedOrderType = [5, 12];

  isLocationNotFound: boolean = false;


  constructor(
    injector : Injector,
    private _testService: TestService,
    private customLocalization: CustomLocalizationService,
    private _userPermissionService: UserPermissionServiceProxy,
  ) {
    super(injector);
  }


  ngOnInit() {
    this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TRANSFER.HEADER"));
	  this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TRANSFER.SUBHEADER"));

    //Kullanıcı bazlı nokta ve sahış bilgilerinin getirildiği method.
		//Hasan ve Burak Abi teyitli olarak değiştirildi.
		this.GetUserAssignedCityList();


		this.onKeyPressAddress();
  }

  //o müşteriye atanmış şehirlerin listesini getir diyoruz
	private GetUserAssignedCityList() {

		this._userPermissionService.getUserAssignedCityList(this.selectedOrderType)
			.subscribe((cityList) => {

				this.cities.next(cityList);
			})

	}

  onKeyPressAddress() {

		this.addressSearchFilter.valueChanges.pipe(debounceTime(500)).subscribe(result => {

			this.isLocationNotFound = false;

			//Bir şehir seçili ise gir diyoruz.
			if (this.selectedCity.cityId) {

				//Eğer bir adres seçili ise ve result null ise aşağıda ki işlemleri yapma diyoruz.
				//Bu sayede eski seçili olan yeni bir arama yapılana kadar kalıyor.
				if (this.selectedAddressObj && result == "") {
					return;
				}

				//eğer bir adres seçilmemiş ise ve aranacak bir kelime girilmediyse
				//ilk anda yüklenen datayı yükle diyoruz.
				if (result == "") {
					this.locationObjListByCity.next(this.initialLocationByCity);

				}

				//bir kelime aranmış ise yani adres aranmış ve kelime uzunluğu 3 den küçükse
				//ilk anda ki tüm datayı içeri bas diyoruz.
				if (result != "" && this.addressSearchFilter.value.trim().length < 3) {

					return this.locationObjListByCity.next(this.initialLocationByCity);
				}

				//search comobobox bir kelime yazılmış ise ve bu kelime 3 den küçükse içeri girme diyoruz.
				//aslında bu koşula ihtiyaçda yok gibi, bunu kaldırıp test edilecek.
				let searchLocation = this.addressSearchFilter.value.trim();
				if (searchLocation.length < 3) {

					return;
				}

				this._userPermissionService
					.getUserCitiesAddressWithUserAssignedAddresses(this.selectedOrderType, this.selectedCity.cityId, this.addressSearchFilter.value)
					.subscribe(resp => {

						if (resp.addresses.length < 1) {

							this.isLocationNotFound = true;
						}

						this.locationObjListByCity.next(resp.addresses);
						this.locationByCity = resp.addresses;

						this.selectedAddressObj = null;
						this.SendToObject();

						

					});

			}

		})

	}
	
  //Gönderilecek olan datalarımızı burada yayıncıya ekleriz.
	private SendToObject() {

		this.dynamicComponentObject.next({
			
			targetAddressObject: this.selectedAddressObj,
		});
	}


  onChangeCity(){

  }

  onChangeLocation(){

  }
  onClickLocation(){
	
  }


  ngOnDestroy(): void {
    this.dynamicComponentObject.unsubscribe();

  }
  

}
